import React from 'react';

import { Text } from '@chakra-ui/react';

import SpinnerWrapper from 'components/App/PartnerProvider/SpinnerWrapper';
import Spinner from 'components/Spinner';
import { FormContainer } from 'modules/Login/FormContainer';
import { translations } from 'new/form/common/types';
import { useQueryParamsToken } from 'shared/hooks/useQueryParamToken';
import { useTranslations } from 'utils/hooks/useTranslations';

import { RegistrationForm } from './RegistrationForm';
import { validateInvitationTokenAction } from './service';

const { linkExpired } = translations.pages.finishRegistration;

export const FinishRegistration = () => {
  const t = useTranslations();

  const { isTokenValidationPending, token } = useQueryParamsToken(validateInvitationTokenAction);

  if (isTokenValidationPending) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  if (!token) {
    return (
      <FormContainer>
        <Text data-testid="invitation-link-expired" textAlign="center">
          {t(linkExpired)}
        </Text>
      </FormContainer>
    );
  }
  return <RegistrationForm invitationToken={token} />;
};
